import React from 'react'
import Head from 'next/head'

import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { KinerjaLandingPage } from 'app/KinerjaLandingPage/pages/KinerjaLandingPage'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isEnabled = toggle?.['kinerja-2025-landing-page-enabled'] === true

    if (!isEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page = (_props: PageProps) => (
  <>
    <Head>
      <title>Pengelolaan Kinerja</title>
    </Head>
    <KinerjaLandingPage />
  </>
)

Page.Layout = ({ children }) => children

export default Page
